// src/features/softwareLicenses/services/softwareLicenses.js
import { apiClient } from '../../../services/api/client';

export const softwareLicensesAPI = {
  // Get all licenses
  getAllLicenses: (params = {}) => 
    apiClient.get('/api/v1/software-licenses/', { params }),
  
  // Get unactivated licenses
  getUnactivatedLicenses: (params = {}) => 
    apiClient.get('/api/v1/software-licenses/unactivated', { params }),
  
  // Get licenses by department
  getDepartmentLicenses: (departmentId, params = {}) => 
    apiClient.get(`/api/v1/software-licenses/department/${departmentId}`, { params }),
  
  // Get license by ID
  getLicenseById: (licenseId) => 
    apiClient.get(`/api/v1/software-licenses/${licenseId}`),
  
  // Activate license
  activateLicense: (licenseId, data) => 
    apiClient.post(`/api/v1/software-licenses/${licenseId}/activate`, data),
  
  // Deactivate license
  deactivateLicense: (licenseId) => 
    apiClient.post(`/api/v1/software-licenses/${licenseId}/deactivate`),
  
  // Delete license
  deleteLicense: (licenseId) => 
    apiClient.delete(`/api/v1/software-licenses/${licenseId}`),
  
  // Get statistics
  getStatistics: () => 
    apiClient.get('/api/v1/software-licenses/statistics/overview'),
};